<template>
    <div>
        <section class="l-section l-section--tall">
            <ThumbList
                :title="page.content.header_title"
                titleClass="t-t1-serif"
                :categories="categories"
            />
        </section>

        <Instagram />
    </div>
</template>

<script>/* eslint-disable */

    import Btn from 'components/Btn'
    import ThumbList from 'components/ThumbList'
    import Instagram from 'components/Instagram'
    import Icon from 'components/Icon'

    import Meta from 'mixins/meta'

    import { mapGetters } from 'vuex'
    import merge from 'lodash/merge'

    export default {
        name: 'Menu',
        components: {
            Btn,
            ThumbList,
            Instagram,
            Icon
        },
        props: {
            page: Object,
            site: Object
        },
        mixins: [ Meta ],
        computed: {

            ...mapGetters('ueat', ['getCategoryById']),

            categories() {

                if ( !this.page.content )
                    return

                if ( !this.page.content.categories )
                    return

                const _ = this
                const _categories = this.page.content.categories

                return _categories.map(p => (
                    _.getCategoryById(p.category)
                ))

            }
        }
    }
</script>

<style>
</style>
